<template>
	<md-select v-model="value"
			   @input="input"
			   @keydown.tab="tabbed"
			   @md-opened="opened"
			   :md-class="contentClass"
			   v-bind="$attrs"
			   v-on="$listeners"
			   :disabled="disabled"
			   :required="required"
			   ref="internal"
	>
		<md-field v-if="searchAllow" style="padding:0.8rem 1rem">
			<label style="padding:0 1rem">{{ $t("common.search") }}</label>
			<md-input @input="search" :value="searchValue" ref="searchInput"></md-input>
		</md-field>
		<slot name="before"/>
		<slot v-if="!options"/>
		<md-option v-else v-for="item in filtered" :value="getOptionValue(item)" :key="getOptionKey(item)">
			<template v-if="renderOptionAsHtml">
				<span v-html="getOptionDisplayValue(item)"></span>
			</template>
			<template v-else>
				{{ getOptionDisplayValue(item) }}
			</template>
		</md-option>
		<md-option v-if="filtered && filtered.length === 0" disabled>
			{{ emptyText }}
		</md-option>
		<slot name="after"/>
	</md-select>
</template>

<script>

import SelectBaseComponent from "@/components/templates/common/SelectBaseComponent";

export default {
	extends: SelectBaseComponent,
	props: {
		value: { },
		// Only works when the select gets a render update call after it is initialized. Try the initial setup in "created()" to make it work.
		renderOptionAsHtml: { type: Boolean, default: false },
		contentSize: { type: "small" | "medium" | "large" | "xl", default: "medium" },
		blacklistFunction: { type: Function, default: null }
	},
	computed: {
		contentClass() {
			return "md-select-menu-content-" + this.contentSize;
		},
		filtered() {
			return this.searchResults.filter(item => !this.shouldRemoveOption(item))
		}
	},
	methods: {
		shouldRemoveOption(item) {
			return this.blacklistFunction && this.blacklistFunction(item)
		},
		input(value) {
			this.$emit("input", value);
		},
		tabbed() {
			// Fix: Prevents a bug where selected values change when navigating using the tab button in a form with multiple selects.
			this.$refs.internal.$refs.menu.destroyKeyDownListener();

			// Also add the desired behaviour that a select closes by using the tab button.
			if (this.$refs.internal.showSelect) {
				document.body.click();
			}
		},
		opened() {
			// Fix: Make sure the current element has focus, otherwise it can happen that keyboard navigation also
			// triggers for previously used select fields as those are somehow still focused.
			// This has to happen a little delayed because the previous select is focused on close, so we make sure
			// this happens afterwards.
			// Also see: https://github.com/vuematerial/vue-material/issues/2136
			setTimeout(function() {
				if (this.searchAllow) {
					this.$refs.searchInput.$el.focus();
				} else {
					this.$refs.internal.onFocus();
				}
			}.bind(this), 1);
		},
	}
};
</script>